import type { PropsWithChildren } from 'react';
import type React from 'react';

import { StartAPetitionPageStateContextProvider } from './context';
import { useStartAPetitionState } from './hooks';

export const StartAPetitionPageStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const { actions, data } = useStartAPetitionState();

	return (
		<StartAPetitionPageStateContextProvider actions={actions} data={data}>
			{children}
		</StartAPetitionPageStateContextProvider>
	);
};
